class DropdownMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: '.shopify-section-header',
      background: '.header-background',
      topMenuItem: '.header__menu-item--top',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.list-menu-dropdown > .list-menu'
    };
    this.timeout;

    //this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;

    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.resetBackground();
    this.animateMenu();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);

    this.header = this.header || document.querySelector(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper)
    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  addClasses() {
    const isTopLevel = this.querySelector(this.selectors.topMenuItem);

    let delay = 0;
    if (isTopLevel && !this.isHover()) {
      delay = 150;

      if (this.closest('.header--top-center') || this.closest('.header--top-left')) {
        delay = 200;
      }
    }
    this.timeout = setTimeout(() => {
      if (this.isHover()) {
        this.classList.add(this.classes.active);
      }
    }, delay);

    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);

    menus.forEach((menu) => {
      let found = false;
      const childMenus = menu.querySelectorAll('dropdown-menu');
      childMenus.forEach((element) => {
        if (element === this) {
          found = true;
          return;
        }
      });

      if (!found) menu.reset();
    });
  }

  isHover() {
    return this.header.classList.contains(this.classes.hover);
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate =  this.querySelector(this.selectors.childAnimate);
    if (childAnimate) childAnimate.classList.remove(this.classes.animate);

    clearTimeout(this.timeout);
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  animateMenu() {
    const childAnimate =  this.querySelector(this.selectors.childAnimate);
    if (childAnimate) {
      setTimeout(() => {
        childAnimate.classList.add(this.classes.animate);
      }, 150);
    }
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('dropdown-menu', DropdownMenu);

class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
    };
    this.selectors = {
      header: '.shopify-section-header',
      background: '.header-background',
      dropdown: '.list-menu-dropdown',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.mega-menu__item, .mega-menu__promo, .mega-menu-sidebar__card'
    };
    this.timeout = [];

    this.sidebarNavItems = this.querySelectorAll('.mega-menu-sidebar__nav-item[data-panel-index]');
    this.sidebarPanels = this.querySelectorAll('.mega-menu-sidebar__panel');

    if (this.sidebarNavItems.length) {
      this.onSidebarActivate = this.onSidebarActivate.bind(this);
      this.sidebarNavItems.forEach((item) => {
        item.addEventListener('mouseenter', this.onSidebarActivate);
        item.addEventListener('focusin', this.onSidebarActivate);
      });
    }

    //this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener('mouseenter', this.handleMouseover.bind(this));
  }

  onSidebarActivate(event) {
    const item = event.currentTarget;
    const panelIndex = item.dataset.panelIndex;
    if (!panelIndex) return;

    this.sidebarNavItems.forEach((navItem) => {
      navItem.classList.toggle(this.classes.active, navItem === item);
    });

    this.sidebarPanels.forEach((panel) => {
      const isActive = panel.dataset.panelIndex === panelIndex;
      panel.classList.toggle('is-active', isActive);

      if (isActive) {
        panel.querySelectorAll(this.selectors.childAnimate).forEach((card, index) => {
          card.classList.remove(this.classes.animate);
          const timeout = setTimeout(() => {
            card.classList.add(this.classes.animate);
          }, (index * 75) + 50);
          this.timeout.push(timeout);
        });
      }
    });

  }

  lockSidebarLayout(force) {
    const sidebar = this.querySelector('.mega-menu-sidebar');
    const panelsWrap = sidebar?.querySelector('.mega-menu-sidebar__panels');
    if (!sidebar || !panelsWrap || !this.sidebarPanels.length) return;
    if (sidebar.classList.contains('is-height-locked') && !force) return;

    const panelsWidth = panelsWrap.clientWidth;
    let maxPanelHeight = 0;
    const prevPosition = panelsWrap.style.position;
    panelsWrap.style.position = 'relative';

    this.sidebarPanels.forEach((panel) => {
      const prevStyle = panel.style.cssText;

      panel.style.cssText = [
        'display:block',
        'visibility:hidden',
        'position:absolute',
        'left:0',
        'top:0',
        'width:' + (panelsWidth ? panelsWidth + 'px' : '100%'),
        'pointer-events:none'
      ].join(';');

      maxPanelHeight = Math.max(maxPanelHeight, panel.offsetHeight);
      panel.style.cssText = prevStyle;
    });

    panelsWrap.style.position = prevPosition;

    const aside = sidebar.querySelector('.mega-menu-sidebar__aside');
    const asideHeight = aside ? aside.offsetHeight : 0;
    const sidebarMinHeight = parseFloat(getComputedStyle(sidebar).minHeight) || 0;
    const lockedHeight = Math.ceil(Math.max(maxPanelHeight, asideHeight, sidebarMinHeight));

    sidebar.classList.add('is-height-locked');
    sidebar.style.setProperty('--mm-locked-height', lockedHeight + 'px');
    this.style.setProperty('--mm-locked-height', lockedHeight + 'px');
  }

  onSidebarResize() {
    if (!this.classList.contains(this.classes.active)) return;

    this.unlockSidebarLayout();
    requestAnimationFrame(() => {
      this.lockSidebarLayout(true);
      this.updateSidebarBackground();
    });
  }

  bindSidebarResize() {
    this.onSidebarResizeEvent = this.onSidebarResizeEvent || this.onSidebarResize.bind(this);
    window.addEventListener('resize', this.onSidebarResizeEvent, { passive: true });
  }

  unbindSidebarResize() {
    if (this.onSidebarResizeEvent) {
      window.removeEventListener('resize', this.onSidebarResizeEvent);
    }
  }

  unlockSidebarLayout() {
    const sidebar = this.querySelector('.mega-menu-sidebar');
    if (sidebar) {
      sidebar.classList.remove('is-height-locked');
      sidebar.style.removeProperty('--mm-locked-height');
    }
    this.style.removeProperty('--mm-locked-height');
  }

  updateSidebarBackground() {
    if (!this.classList.contains('is-megamenu--sidebar')) return;

    this.header = this.header || document.querySelector(this.selectors.header);
    if (!this.header) return;

    const dropdown = this.querySelector(this.selectors.dropdown);
    const background = this.header.querySelector(this.selectors.background);
    if (!dropdown || !background) return;

    background.style.setProperty('--height', this.header.clientHeight + dropdown.clientHeight + 'px');
    background.classList.add(this.classes.active);
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;
    
    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.showSublist();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
  }

  handleTouchMoveOutside(ev) {
    if (!this.header) return;
    
    let target_section = ev.targetTouches[0].target.closest(this.selectors.header);
    if(!target_section || this.header.classList.contains('shopify-section-header-hidden')) {
      this.reset();
      this.resetBackground();
      
      this.header.classList.remove(this.classes.hover);
      document.removeEventListener('touchmove', this.onHeaderTouchMoveOutsideEvent);
    }
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);
    this.onHeaderTouchMoveOutsideEvent = this.onHeaderTouchMoveOutsideEvent || this.handleTouchMoveOutside.bind(this);
    
    this.header = this.header || document.querySelector(this.selectors.header);

    if (this.classList.contains('is-megamenu--sidebar')) {
      this.wrapper = this.closest('.header-wrapper');
    } else {
      this.wrapper = this.closest(this.selectors.wrapper);
    }

    this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
    document.addEventListener('touchmove', this.onHeaderTouchMoveOutsideEvent);
  }

  showSublist() {
    if (this.classList.contains('is-megamenu--sidebar')) {
      this.bindSidebarResize();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.lockSidebarLayout();
          this.updateSidebarBackground();
        });
      });
      return;
    }

    const dropdown = this.querySelector(this.selectors.dropdown);
    const background = this.header.querySelector(this.selectors.background);
    background.style.setProperty('--height', this.header.clientHeight + dropdown.clientHeight + 'px');
    background.classList.add(this.classes.active);
  }

  addClasses() {
    this.classList.add(this.classes.active);

    let childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    if (this.classList.contains('is-megamenu--sidebar')) {
      const activePanel = this.querySelector('.mega-menu-sidebar__panel.is-active');
      if (activePanel) {
        childAnimate = activePanel.querySelectorAll(this.selectors.childAnimate);
      }
    }

    const delay = childAnimate.length > 5 ? 75 : 150;
    childAnimate.forEach((element, index) => {
      const timeout = setTimeout(() => {
        element.classList.add(this.classes.animate);
      }, (delay * index) + 100);

      this.timeout.push(timeout);
    });

    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);
    menus.forEach((menu) => {
      menu.reset();
    });
  }

  reset() {
    this.classList.remove(this.classes.active);

    if (this.classList.contains('is-megamenu--sidebar')) {
      this.unlockSidebarLayout();
      this.unbindSidebarResize();
    }

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    childAnimate.forEach((element) => {
      element.classList.remove(this.classes.animate);
    });
    this.timeout.forEach((timeout) => {
      clearTimeout(timeout);
    });
    this.timeout = [];
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define('mega-menu', MegaMenu);
